module.exports = __webpack_public_path__ + "4d456064ccd16ab9be74dfb55e7dfb25.svg";